import './style.less';

export default function($log, ApiClass, UserClass) {
  'ngInject';

  const vm = this;
  $log.debug('Event Component Activated');
  vm.loaded = false;
  vm.$onInit = activate;

  vm.admin = UserClass.admin || UserClass.team_leader;

  vm.scormUpdate = () => {
    vm.loaded = false;
    ApiClass.eventsIdTypeTypeIdPatch(
      { id: vm.event.event_id, type: 'scormAttendee', type_id: vm.event.registration_id },
      {},
      {}
    )
      .then(() => {
        activate();
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  function setEvent(event, otherEvents) {
    vm.event = event;
    vm.selectedEvent = vm.event.delivery_location;
    vm.otherEvents = otherEvents;
    vm.loaded = true;
  }

  function activate() {
    if (vm.externalEvent) {
      vm.loaded = true;
      return (vm.event = vm.externalEvent);
    }
    if (vm.event && vm.otherEvents) {
      return setEvent(vm.event, vm.otherEvents);
    }
    ApiClass.eventsIdGet({ id: vm.eventId })
      .then(({ data }) => {
        $log.debug('Event Data:', data);
        setEvent(data.event, data.otherEvents);
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = { status: error.status, refresh: activate };
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/event/controller.js